const styles = () => ({
  root: {
    '&:hover': {
      backgroundColor: 'unset',
    },
    color: 'black',
    '& .icon-approved': {
      color: 'black',
      fontSize: '38px',
      width: '33px',
      height: '33px',
      border: '1px solid transparent',
      borderRadius: '4px',
      boxShadow: 'none',
      '@media (max-width:767px)':{
        fontSize:'24px',
        height:'24px'
      },
      '&:before': {
        marginTop: '-5px',
        display: 'block',
      },
    },
  },
  radioNotChecked: {
    color: 'black',
    width: '33px',
    fontSize: '38px',
    height: '33px',
    border: '1px solid #B6B6B6',
    borderRadius: '4px',
    boxShadow: '0 0 3px #666666 inset',
    '@media (max-width:767px)':{
      fontSize:'24px',
      height:'24px',
      width:'24px'
    },
  },
})

export default styles
